(function () {
    document.addEventListener("DOMContentLoaded", (event) => {
        const scrollSpySections = document.querySelectorAll(".scrollspy-section");
        const scrollspyNavigation = document.querySelector(".scrollspy-navigation");

        if (scrollspyNavigation) {
            const navLinks = scrollspyNavigation.querySelectorAll("a");

            if (detectIE()) {
                // Small delay needed for IE11 cssVars polyfill, otherwise section positions are wrong.
                setTimeout(function () { scrollSpy.updateSectionPositions(scrollSpySections, scrollspyNavigation) }, 500);
            } else {
                scrollSpy.updateSectionPositions(scrollSpySections, scrollspyNavigation);
            }

            if (matchMedia) {
                for (let key in breakpoints) {
                    const windowMatchBp = window.matchMedia(`(min-width: ${breakpoints[key]}px)`);
                    windowMatchBp.addListener(function () {
                        if (windowMatchBp.matches) {
                            scrollSpy.updateSectionPositions(scrollSpySections, scrollspyNavigation);
                        } else {
                            scrollSpy.updateSectionPositions(scrollSpySections, scrollspyNavigation);
                        }
                    });
                }
            }

            scrollSpy.updateNavCurrentPosition(scrollSpySections, scrollspyNavigation);

            Array.prototype.forEach.call(navLinks, (currentNavLink) => {
                currentNavLink.addEventListener("click", (event) => {
                    scrollSpy.scrollToSection(event, currentNavLink);
                });
            });
        }
    });

    const scrollSpy = {
        data: {
            sectionPositions: {}
        },
        scrollToSection: function (event, currentNavLink) {
            event.preventDefault();
            const targetId = currentNavLink.getAttribute("href").split('#').join("");
            const _this = this;

            window.scroll({
                left: 0,
                top: _this.data.sectionPositions[targetId],
                behavior: 'smooth'
            });
        },
        updateSectionPositions: function (scrollSpySections, scrollspyNavigation) {
            Array.prototype.forEach.call(scrollSpySections, (currentScrollSpySection) => {
                this.data.sectionPositions[currentScrollSpySection.id] = this.getSectionsPosition(currentScrollSpySection, scrollspyNavigation);
            });
        },
        getSectionsPosition: function (el, scrollspyNavigation) {
            const mainNavigation = document.querySelector(".navigation-bar-holder");

            for (let key in breakpoints) {
                if (window.matchMedia(`(min-width: ${breakpoints[key]}px)`).matches) {
                    return el.offsetTop - (mainNavigation.offsetHeight + scrollspyNavigation.offsetHeight);
                }
            }
        },
        getNavItemsPosition: function (el) {
            for (let key in breakpoints) {
                if (window.matchMedia(`(min-width: ${breakpoints[key]}px)`).matches) {
                    return el.offsetLeft;
                }
            }
        },
        updateNavCurrentPosition: function (sections, nav) {
            const observerConfig = {
                root: null,
                rootMargin: '-50% 0px -50% 0px',
                threshold: 0
            };

            const intersectionObserver = new IntersectionObserver(function (entries) {
                const navLinks = nav.querySelectorAll("a");
                const scrollspyNavigation = document.querySelector(".scrollspy-navigation");
                const containerPadding = 23;

                Array.prototype.forEach.call(navLinks, (item) => {
                    item.classList.remove("active-scroll");
                    item.blur();
                });

                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        let intersectingSection = entry.target;
                        let intersectingSectionId = intersectingSection.getAttribute("id");
                        let currentNavLink = nav.querySelector(`a[href="#${intersectingSectionId}"]`);
                        intersectingSection.classList.add("active-scroll");
                        currentNavLink.classList.add("active-scroll");

                        let newScrollPosition = (currentNavLink.offsetLeft - scrollspyNavigation.scrollLeft) - containerPadding;
                        scrollspyNavigation.scrollBy({ top: 0, left: newScrollPosition, behavior: 'smooth' });

                    } else {
                        let notIntersectingSection = entry.target;
                        notIntersectingSection.classList.remove("active-scroll");
                    }
                });

            }, observerConfig);

            Array.prototype.forEach.call(sections, (section) => {
                intersectionObserver.observe(section);
            });
        }
    };
})();